import React from 'react'

export default props => (
  <svg viewBox="0 0 18 18" {...props}>
    <path d="M7.09,12.59 L8.5,14 L13.5,9 L8.5,4 L7.09,5.41 L9.67,8 L0,8 L0,10 L9.67,10 L7.09,12.59 Z M16,0 L2,0 C0.89,0 0,0.9 0,2 L0,6 L2,6 L2,2 L16,2 L16,16 L2,16 L2,12 L0,12 L0,16 C0,17.1 0.89,18 2,18 L16,18 C17.1,18 18,17.1 18,16 L18,2 C18,0.9 17.1,0 16,0 Z" />
  </svg>
)



// WEBPACK FOOTER //
// ./src/Assets/Images/icons/logout.js